import { render } from "./RedirectPage.vue?vue&type=template&id=12fbc1c8&scoped=true&ts=true"
import script from "./RedirectPage.vue?vue&type=script&lang=ts"
export * from "./RedirectPage.vue?vue&type=script&lang=ts"

import "./RedirectPage.vue?vue&type=style&index=0&id=12fbc1c8&scoped=true&lang=css"

import exportComponent from "/Users/pontustengroth/Desktop/git/shipd/apps/shipd-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12fbc1c8"]])

export default __exports__